import React, { FC, useCallback } from 'react';
import { Asset, Button, CloseIcon, Modal } from '@clearcover/atlas';

import { FeeLineProps, FeeModalProps } from './types';
import styles from './styles.module.css';

export const FeeModal: FC<FeeModalProps> = ({
  open,
  onClose,
  title,
  infoCopy,
  feeLines,
  footNote,
}) => {
  const renderFeeLine = useCallback(
    ({ feeAmount, feeName, feeId }: FeeLineProps & { feeId: number }) => {
      return (
        <li key={feeId} className={styles.feeLine}>
          <p>
            {feeName}
            <span>{feeAmount}</span>
          </p>
        </li>
      );
    },
    []
  );

  return (
    <Modal
      controlled
      open={open}
      variant="xl"
      handleClose={onClose}
      showCloseIcon={false}
    >
      {closeModal => (
        <div className={styles.feeModal}>
          <div className={styles.modalHeader}>
            <h3>{title}</h3>
            <button data-testid="close-fee-modal" onClick={closeModal}>
              <Asset
                icon={CloseIcon}
                description="Close Fee Modal"
                height={16}
                width={16}
              />
            </button>
          </div>
          <div className={styles.modalContent}>
            <p className={styles.infoCopy}>{infoCopy}</p>
            <ul className={styles.feeList}>
              {feeLines.map(({ feeName, feeAmount }, idx) =>
                renderFeeLine({ feeName, feeAmount, feeId: idx })
              )}
            </ul>
          </div>
          <div className={styles.modalFooter}>
            {footNote && <p className={styles.footNote}>{footNote}</p>}
            <Button
              type="button"
              variant="primary"
              className={styles.closeButton}
              onClick={closeModal}
            >
              Ok
            </Button>
          </div>
        </div>
      )}
    </Modal>
  );
};
